import { useTranslation } from 'react-i18next';
import { Chapter } from './AudioSegmentManager';
import { Controller, useForm } from 'react-hook-form';
import { Typography } from '@mui/material';
import { FormTinyMCEInput } from '@wajeez-web/components/form-builder';
import { Modal } from '@wajeez-web/components/ui';

interface AddChapterModalProps {
  currentTime: number;
  duration: number;
  onAdd: (chapter: Chapter) => void;
  onClose: () => void;
  isOpen: boolean;
  isRtl: boolean;
}

interface ChapterForm {
  title: string;
  text: string;
}

export const AddChapterModal = ({
  currentTime,
  duration,
  onAdd,
  onClose,
  isOpen,
  isRtl,
}: AddChapterModalProps) => {
  const { t } = useTranslation();

  const {
    control,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm<ChapterForm>({
    mode: 'all',
    defaultValues: { title: '', text: '' },
  });

  const onSubmit = (data: ChapterForm) => {
    const newChapter: Chapter = {
      title: data.title.trim(),
      text: data.text.trim(),
      point: (currentTime / duration) * 100,
    };

    onAdd(newChapter);
    reset();
    onClose();
  };

  if (!isOpen) return null;

  return (
    // <Modal
    //   title={'Add Chapter'}
    //   withScroll={true}
    //   open={isOpen}
    //   onClose={onClose}
    //   fontClassName="font-[Tajawal]"
    //   overflowClassName="overflow-y-hidden"
    //   alertTarget="modal"
    //   zIndexClassName="z-20"
    //   widthClassName="w-[70%]"
    // >
    <div
      className="modal bg-white border rounded-lg text-[12px] font-bold absolute z-50 w-3/4 right-[170px]"
      style={{
        top: `${(currentTime / duration) * 100}%`,
        boxShadow: '0 4px 6px rgba(0,0,0,0.1)',
      }}
      onClick={(e) => e.stopPropagation()}
    >
      <form
        className="flex flex-col justify-center gap-2 my-5 w-full px-5"
        onSubmit={handleSubmit(onSubmit)}
      >
        <Typography variant="h6">{t('inputs.labels.Title')}</Typography>
        <Controller
          name="title"
          control={control}
          rules={{
            required: t('inputs.messages.Required') ?? 'This field is required',
          }}
          render={({ field }) => (
            <input
              {...field}
              className={`border text-gray-900 text-sm rounded-lg block w-full p-2.5 ${
                errors.title
                  ? 'border-red-600 focus:border-red-600 focus:ring-red-600'
                  : 'border-gray-300 focus:border-blue-500'
              }`}
              placeholder={
                t('inputs.placeholders.Enter chapter title') ??
                'Enter chapter title'
              }
            />
          )}
        />
        {errors.title && (
          <div className="text-red-600 text-[12px] font-medium">
            {errors.title.message}
          </div>
        )}

        <FormTinyMCEInput
          isRtl={isRtl}
          control={control}
          name="text"
          fieldType={{
            fieldType: 2,
            fieldOptions: {},
            // required: true,
            label: 'Text',
          }}
        />

        <div className="flex justify-around items-center w-full mt-3">
          <button
            type="submit"
            className="bg-blue-400 p-3 rounded-lg text-[13px] font-medium text-white"
          >
            {t('buttons.Save')}
          </button>
          <button
            type="button"
            className="bg-red-500 p-3 rounded-lg text-[13px] font-medium text-white"
            onClick={() => {
              reset();
              onClose();
            }}
          >
            {t('buttons.Cancel')}
          </button>
        </div>
      </form>
    </div>
    // </Modal>
  );
};
